import {TagSchemaItemType} from 'graphql-client/__generated/graphqlGlobalTypes';

export enum EntityCreationFeatureType {
  REGISTRATION_TABLE = 'REGISTRATION_TABLE',
  LEGACY_REGISTRATION_TABLE = 'LEGACY_REGISTRATION_TABLE',
  ADD_FROM_SPREADSHEET_TO_REGISTRATION_TABLE = 'ADD_FROM_SPREADSHEET_TO_REGISTRATION_TABLE',
}

/**
 * Additional entity types that are not `TagSchemaItemType`s but force their own special entity creation
 * flows.
 */
export enum AdditionalCreatableEntityType {
  TRIAL_SAMPLE = 'TRIAL_SAMPLE',
}

export type CreatableEntityType = TagSchemaItemType | AdditionalCreatableEntityType;
